// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '2bad551e-5782-4d7c-83fe-7a493d2d6a83',
      type: 'NineSlicePlane',
      name: 'background',
      className: '',
      x: -381,
      y: -82,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 762,
      height: 161,
      leftWidth: 55,
      topHeight: 45,
      rightWidth: 53,
      bottomHeight: 72,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Free_Gift_Shop_Background_9Slice_55x45x53x45x72',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'd17f2472-bd6e-45f0-b742-dcabecc8c092',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: -256,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        rotationCycle: 30000
      }
    },
    {
      id: '4631c8bf-ba30-45c0-ade9-06b087ed62c3',
      type: 'Sprite',
      name: 'raysMask',
      className: '',
      x: -367,
      y: -70,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.85034
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Smaller_Beige_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'c3091ac7-3d0f-447c-a03c-fdefd805485e',
      type: 'Container',
      name: 'particleSlot',
      className: '',
      x: -256,
      y: -6,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '8d1b237e-290f-43e4-ab54-ff7b871f5adf',
      type: 'Container',
      name: 'giftBoxClosed',
      className: '',
      x: -266,
      y: 11,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        locked: {
          alpha: 0
        }
      }
    },
    {
      id: '1de5692b-88bf-42ab-8db3-4e6ebfd2b341',
      type: 'Container',
      name: 'giftBoxOpened',
      className: '',
      x: -266,
      y: 37,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        locked: {
          visible: true,
          alpha: 1
        }
      }
    },
    {
      id: '48ac57fb-39a7-4554-ad38-c59dc7755b1f',
      type: 'Container',
      name: 'claimButton',
      className: '',
      x: 220,
      y: -16,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        locked: {
          visible: true,
          alpha: 0
        }
      }
    },
    {
      id: '686c3f5d-082b-49f3-bbbf-30b13c82576e',
      type: 'Container',
      name: 'countdownButton',
      className: '',
      x: 220,
      y: -16,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        locked: {
          visible: true,
          alpha: 1
        }
      }
    },
    {
      id: 'd9227a99-9a69-4911-95ff-1b15f74f6ec8',
      type: 'Container',
      name: 'itemSlot',
      className: '',
      x: -258,
      y: -36,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0e38a09b-9ef3-46f0-8b31-5b1a0231e32a',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.882353,
        y: 1.473684
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12684396,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gift_Open_Shadow',
      parent: '8d1b237e-290f-43e4-ab54-ff7b871f5adf'
    },
    {
      id: '6b0f58df-ba83-49d4-a544-608c65156e89',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 26,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gift_Blue_Box',
      parent: '8d1b237e-290f-43e4-ab54-ff7b871f5adf'
    },
    {
      id: 'ad00facd-0101-44dc-a8fb-f4feac7bab65',
      type: 'Sprite',
      name: 'boxLid',
      className: '',
      x: 0,
      y: -13,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gift_Blue_Lid',
      parent: '8d1b237e-290f-43e4-ab54-ff7b871f5adf'
    },
    {
      id: '76b7a891-412d-4f10-95a0-e1b33c65ba01',
      type: 'Sprite',
      name: 'notificationDot',
      className: '',
      x: 51,
      y: -51,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Notification_Dot',
      parent: '8d1b237e-290f-43e4-ab54-ff7b871f5adf'
    },
    {
      id: '98bd72b0-b76c-4db8-8605-78e189967515',
      type: 'Sprite',
      name: 'notificationDotFlash',
      className: '',
      x: 51,
      y: -51,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.125,
        y: 0.128906
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      parent: '8d1b237e-290f-43e4-ab54-ff7b871f5adf'
    },
    {
      id: '69d13b3a-87af-480b-b122-a9a1cd25813c',
      type: 'Sprite',
      name: '',
      className: '',
      x: -20,
      y: 5,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12684396,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gift_Open_Shadow',
      parent: '1de5692b-88bf-42ab-8db3-4e6ebfd2b341'
    },
    {
      id: '2800ca5f-d92e-4938-b466-e70a1c89f669',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gift_Blue_Box',
      parent: '1de5692b-88bf-42ab-8db3-4e6ebfd2b341'
    },
    {
      id: 'f4d89e64-fa13-46df-ada1-3dd36af4b95d',
      type: 'Sprite',
      name: '',
      className: '',
      x: -17,
      y: -2,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 18592,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gift_Shadow',
      parent: '1de5692b-88bf-42ab-8db3-4e6ebfd2b341'
    },
    {
      id: '21715f59-3175-44fd-89f6-484b47d1540f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -23,
      y: -23,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -41,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gift_Blue_Lid',
      parent: '1de5692b-88bf-42ab-8db3-4e6ebfd2b341'
    },
    {
      id: 'fe1699d0-66f6-4dd8-a514-eb0f8587f969',
      type: 'Layout',
      name: 'button1',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 1,
      scale: {
        x: 0.77,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '48ac57fb-39a7-4554-ad38-c59dc7755b1f',
      data: {
        color: 'green'
      }
    },
    {
      id: '04f19399-c136-495e-921f-4cbe6412ef74',
      type: 'Text',
      name: 'freeText',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'FREE',
      localize: true,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#01632D',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '48ac57fb-39a7-4554-ad38-c59dc7755b1f'
    },
    {
      id: '4f5285ad-84a0-43f9-80f9-67206f29f8ea',
      type: 'Layout',
      name: 'button2',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 1,
      scale: {
        x: 0.77,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '686c3f5d-082b-49f3-bbbf-30b13c82576e',
      data: {
        color: 'grey'
      }
    },
    {
      id: '10fece05-becb-4064-ac9c-f0c08aa88f8c',
      type: 'Text',
      name: 'collectText',
      className: '',
      x: 0,
      y: -25,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect in',
      localize: true,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#525252',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '686c3f5d-082b-49f3-bbbf-30b13c82576e'
    },
    {
      id: '849f456c-c3ab-4f47-b59d-9ee0c671d503',
      type: 'Text',
      name: 'countdownText',
      className: '',
      x: 0,
      y: 14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Xh Ym',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#525252',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '686c3f5d-082b-49f3-bbbf-30b13c82576e'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'locked'
  ],
  animations: [
    {
      id: '9cebe0f5-23e6-44c5-9947-28f07917027d',
      name: 'Open',
      playingSpeed: 1,
      totalDuration: 2250,
      blocks: [
        {
          id: 'd1de7c6e-044b-4bfd-9f05-85f41561a5cb',
          type: 'Tween',
          name: 'scaleTween_0',
          duration: 250,
          track: 1,
          target: {
            scale: {
              x: 0.95,
              y: 0.95
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: 'f3cc4a69-b9a8-432e-9184-77b75d6970df',
          type: 'Tween',
          name: 'scaleTween_2',
          duration: 220,
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 30,
          sourceName: 'claimButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '90c7de0e-4380-4754-9910-3af41ca150ff',
          type: 'Tween',
          name: 'posTween_0',
          duration: 100,
          track: 7,
          target: {
            y: -5
          },
          startAt: 226,
          sourceName: 'boxLid',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '820b4e0f-b285-45d2-aeb4-98b85015c696',
          type: 'Setter',
          name: 'setAlpha_0',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 250,
          sourceName: 'claimButton',
          disabled: false
        },
        {
          id: 'f0021fc5-307e-47b4-ba0e-70dbb61b2759',
          type: 'Setter',
          name: 'setAlphaAndScale_0',
          track: 3,
          target: {
            alpha: 1,
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 250,
          sourceName: 'countdownButton',
          disabled: false
        },
        {
          id: '92bb2e57-58e1-488a-b51d-ac010a7e6e51',
          type: 'Setter',
          name: 'ANIMEVENT_spawnGift',
          track: 5,
          target: {},
          startAt: 250,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'e9404c35-00d7-475b-b915-f824e0eeeb9f',
          type: 'Tween',
          name: 'scaleTween_3',
          duration: 220,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 250,
          sourceName: 'countdownButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '26517e44-2926-4f37-b1e1-ff6de6557ba5',
          type: 'Tween',
          name: 'scaleTween_1',
          duration: 250,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 250,
          sourceName: 'root',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '422f0677-edd7-4f31-a1e7-7360f0c1beb2',
          type: 'Tween',
          name: 'posTween_1',
          duration: 200,
          track: 7,
          target: {
            y: -93
          },
          startAt: 326,
          sourceName: 'boxLid',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '40292e05-f945-451e-b4a2-112a64c5f511',
          type: 'Tween',
          name: 'angleTween_0',
          duration: 200,
          track: 8,
          target: {
            angle: -20
          },
          startAt: 326,
          sourceName: 'boxLid',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '709268f3-fd3d-4c62-a866-b976b641a35c',
          type: 'Tween',
          name: 'scaleTween_4',
          duration: 50,
          track: 2,
          target: {
            scale: {
              y: 1,
              x: 1
            }
          },
          startAt: 470,
          sourceName: 'countdownButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'f9e546e8-439c-4509-bc20-636bcf6f1fc8',
          type: 'Tween',
          name: 'alphaTween_0',
          duration: 200,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 601,
          sourceName: 'giftBoxClosed',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'ab51fcd8-45ca-49b0-9b16-57ca57e01722',
          type: 'Tween',
          name: 'alphaTween_2',
          duration: 150,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 2000,
          sourceName: 'giftBoxOpened',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: 'd13df2bc-0e8d-4dfe-90d3-587976c3e7dc',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: 'e2daf19d-07f7-4375-9abb-6b7a6f3056e3',
          type: 'Setter',
          name: 'setNotificationDotAlpha',
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'notificationDot',
          disabled: false
        },
        {
          id: '2a5856ba-53cd-4905-b819-9749eba74237',
          type: 'Tween',
          name: 'setNotificationDotScale_0',
          duration: 400,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 0,
          sourceName: 'notificationDot',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'afe7ad24-1563-4c5c-b2d1-86d49d48df00',
          type: 'Tween',
          name: 'setNotificationDotFlashScale_0',
          duration: 400,
          track: 4,
          target: {
            scale: {
              x: 0.19,
              y: 0.19
            }
          },
          startAt: 0,
          sourceName: 'notificationDotFlash',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4e86ccbd-0eba-4286-a7cc-a7b7e7e3bf10',
          type: 'Tween',
          name: 'setNotificationDotFlashAlpha_0',
          duration: 300,
          track: 3,
          target: {
            alpha: 0.25
          },
          startAt: 66,
          sourceName: 'notificationDotFlash',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '69639755-42f6-4dc9-93ee-1dffbd3386df',
          type: 'Tween',
          name: 'setNotificationDotFlashAlpha_1',
          duration: 300,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 398,
          sourceName: 'notificationDotFlash',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'fc6b42b2-5838-4fdf-8503-97a2512aaf2e',
          type: 'Tween',
          name: 'setNotificationDotFlashScale_1',
          duration: 400,
          track: 4,
          target: {
            scale: {
              x: 0.13,
              y: 0.13
            }
          },
          startAt: 400,
          sourceName: 'notificationDotFlash',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '41e5fdaa-83c8-47d9-8f01-790ab3d8e280',
          type: 'Tween',
          name: 'setNotificationDotScale_1',
          duration: 400,
          track: 2,
          target: {
            scale: {
              x: 0.8,
              y: 0.8
            }
          },
          startAt: 400,
          sourceName: 'notificationDot',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class ShopFreeGiftOfferLayout {
  static raw = raw;
  root!: Container;
  background!: NineSlicePlane;
  rays!: Sprite & { data: typeof raw['list'][2]['data'] };
  raysMask!: Sprite;
  particleSlot!: Container;
  giftBoxClosed!: Container;
  giftBoxOpened!: Container;
  claimButton!: Container;
  countdownButton!: Container;
  itemSlot!: Container;
  boxLid!: Sprite;
  notificationDot!: Sprite;
  notificationDotFlash!: Sprite;
  button1!: ButtonLargeLayout & { data: typeof raw['list'][19]['data'] };
  freeText!: Text;
  button2!: ButtonLargeLayout & { data: typeof raw['list'][21]['data'] };
  collectText!: Text;
  countdownText!: Text;
  rotate_SPL!: (Sprite & { data: typeof raw['list'][2]['data'] })[];
  StateName!: 'locked';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Open {
  Layout: {
    root: object;
    claimButton: object;
    boxLid: object;
    countdownButton: object;
    giftBoxClosed: object;
    giftBoxOpened: object;
  };

  BlockTypeByName: {
    scaleTween_0: object;
    scaleTween_2: object;
    posTween_0: object;
    setAlpha_0: object;
    setAlphaAndScale_0: object;
    ANIMEVENT_spawnGift: object;
    scaleTween_3: object;
    scaleTween_1: object;
    posTween_1: object;
    angleTween_0: object;
    scaleTween_4: object;
    alphaTween_0: object;
    alphaTween_2: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle {
  Layout: {
    notificationDot: object;
    notificationDotFlash: object;
  };

  BlockTypeByName: {
    setNotificationDotAlpha: object;
    setNotificationDotScale_0: object;
    setNotificationDotFlashScale_0: object;
    setNotificationDotFlashAlpha_0: object;
    setNotificationDotFlashAlpha_1: object;
    setNotificationDotFlashScale_1: object;
    setNotificationDotScale_1: object;
  };

  flowData = raw.animations[1];
}
